module.exports = __webpack_public_path__ + "img/avartar.a92decd4.png";